<template>
  <div class="box3">
    <pageTitle
      title="用户规模迅速增长<br/>占领互联网流量高地"
      text="短视频正逐渐渗透至生活全场景，成为内容传播渠道标配"
      titleColor="#4d1f2e"
      titColor="#4d1f2e"
    />

    <div class="swiper-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
           <img :src="item.url"/>
           <p v-html="item.p"></p>
           <i>{{item.i}}</i>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <img class="bottom" src="../../../assets/coursePage/newMedia2/box3/img04.png"/>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        autoplay: true,
        
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 18,
       
        // effect: "left",
      },
      list: [
        {
         
          p: `2023年3月2日，中国互联网络信息中心（CNNIC）发布第51次《中国互联网络发展状况统计报告》。<br/>
          《报告》显示，短视频用户规模达<a>10.12亿</a>，用户规模占整体网民<a>94.8%</a>。<br/>
          Mob研究院调研显示，短视频已成为吸引网民的首要渠道，人均每天刷近3小时。`,
          i:'数据来源：中国互联网络信息中心、网经社、抖音热点&巨量算数',
          url: require('../../../assets/coursePage/newMedia2/box3/img01.png')
        },
        {
          p: `字节投资报告显示，2023年抖音电商618总销售额同比增长<a>72.74%</a>，<br/>
          其中直播带货销售额占比81.39%，同比增长<a>68.83%</a>。`,
          i:'字节跳动投资报告Mob研究院《2023年短视频行业研究报告》',
          url: require('../../../assets/coursePage/newMedia2/box3/img02.png')
        },
        {
          p: `“东方甄选”直播间，618累计销售额破<a>3亿</a>；<br/>
          某知名主播<a>一场直播带货销售额几千万</a>；<br/>
          短视频、直播的带货变现能力让人大开眼界！
          `,
          i:'',
          url: require('../../../assets/coursePage/newMedia2/box3/img03.png')
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box3 {
  position: relative;
  width: 100%;
  background:  url("../../../assets/coursePage/newMedia2/box3/bg.png")
    no-repeat;
  background-size: cover;
  background-position: center;

  padding:80px 0 0;
.bottom{
  width: 100%;
  height: auto;
}
  .swiper-box {
    position: relative;
   
  }
  .swiper-slide {
    width: 610px;
    height:862px;
    // background: rgba(245, 252, 255, 0.5);
  }

  .block {
    margin-top: 28px;
    background-color: #ffffff;
	box-shadow: 0px 6px 30px 0px 
		#f0d8e0;
	border-radius: 20px;
    width: 100%;
    height: 742px;
   
    padding: 20px;
  
box-sizing: border-box;
    text-align: center;
img{
  width: 100%;
}
p{
  font-family: PingFang-SC-Regular;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 40px;
	letter-spacing: 0px;
  text-align: left;
	color: #263427;
  margin: 28px 0;
  
   ::v-deep{
    a{
    color: #ff3478;
  }
   }
 
  
}
i{font-family: PingFang-SC-Regular;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 22px;
	letter-spacing: 0px;
  white-space: nowrap;
	color: #999999;}
  }

  .swiper-pagination-box3 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    // background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    margin: 0px 4px;
    width: 10px;
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
}
</style>
